var company = {};
module['exports'] = company;
company.suffix = require("./suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/company/index.js
 ** module id = 886
 ** module chunks = 0
 **/